module.exports = __webpack_public_path__ + "img/data-security.7b5421ae.svg";